import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import UsersGuideImg from "src/assets/images/tour-guide/users-guide.png";
import ChatsGuideImg from "src/assets/images/tour-guide/chats-guide.png";
import DashboardGuideImg from "src/assets/images/tour-guide/dashboard-guide.png";
import ReportsGuideImg from "src/assets/images/tour-guide/reports-guide.png";
import SettingsGuideImg from "src/assets/images/tour-guide/settings-guide.png";

const guideImages: Record<string, string> = {
  "Users Guide": UsersGuideImg,
  "Chats Guide": ChatsGuideImg,
  "Dashboard Guide": DashboardGuideImg,
  "Reports Guide": ReportsGuideImg,
  "Settings Guide": SettingsGuideImg,
};

interface TourGuidanceModalProps {
  open: boolean;
  onClose: () => void;
  onAgree: () => void;
  title?: string;
  content?: string;
}

const TourGuidanceModal: React.FC<TourGuidanceModalProps> = ({
  open,
  onClose,
  onAgree,
  title = "User Guide",
  content = "Do you want to see the user guide?",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 2,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={3} alignItems="center" textAlign="center">
          {/* Icon / Illustration */}
          <Box>
            <img
              src={guideImages[title] ?? UsersGuideImg}
              alt={title}
              style={{ width: 120, height: 120, objectFit: "contain" }}
            />
          </Box>

          {/* Title (from props) */}
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ mt: "12px !important" }}
          >
            {title}
          </Typography>

          {/* Content (from props) */}
          <Typography variant="body2" color="text.secondary">
            {content}
          </Typography>

          {/* Actions */}
          <Stack spacing={1} width="100%">
            <Button
              variant="contained"
              size="large"
              onClick={onAgree}
              sx={{
                borderRadius: 3,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Start Guide
            </Button>

            <Button
              variant="text"
              onClick={onClose}
              sx={{
                textTransform: "none",
                color: "text.secondary",
              }}
            >
              Skip for now
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default TourGuidanceModal;
